import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "NON fumatore", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggler = _resolveComponent("toggler")!
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createVNode(_component_toggler, {
          modelValue: _ctx.value.nonFumatore,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.nonFumatore) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    (!_ctx.value.nonFumatore)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_form_input, {
            type: "text",
            label: "Anno inizio fumo",
            modelValue: _ctx.value.annoInizio,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.annoInizio) = $event)),
            placeholder: "Anno inizio fumo",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"]),
          _createVNode(_component_form_input, {
            type: "text",
            label: "Prezzo pacchetto",
            modelValue: _ctx.value.prezzoPacchettoSigarette,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.prezzoPacchettoSigarette) = $event)),
            placeholder: "Prezzo pacchetto",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"]),
          _createVNode(_component_form_input, {
            type: "text",
            label: "Quante sigarette al giorno",
            modelValue: _ctx.value.quanteSigaretteAlGiorno,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.quanteSigaretteAlGiorno) = $event)),
            placeholder: "Quante sigarette al giorno",
            readonly: _ctx.readonly
          }, null, 8, ["modelValue", "readonly"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}